/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemArtifactCompletionRequestFromJSON(json) {
    return WallItemArtifactCompletionRequestFromJSONTyped(json, false);
}
export function WallItemArtifactCompletionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'artifactId': !exists(json, 'artifact_id') ? undefined : json['artifact_id'],
    };
}
export function WallItemArtifactCompletionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'artifact_id': value.artifactId,
    };
}
//# sourceMappingURL=WallItemArtifactCompletionRequest.js.map